var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMainManuCourses = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.65711C7.98244 4.527 6.17956 4.07744 3.791 4.00044C3.357 3.98566 3 4.34344 3 4.77822V13.9972C3 14.418 3.33678 14.7672 3.75756 14.7734C6.16244 14.8092 7.97311 15.2526 10 16.4441C12.0269 15.2526 13.8376 14.8092 16.2424 14.7734C16.6632 14.7672 17 14.418 17 13.9972V4.77822C17 4.34344 16.643 3.98644 16.209 4.00044C13.8204 4.07744 12.0176 4.527 10 5.65711Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 5.65649V16.4443",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMainManuCourses);
export default ForwardRef;